import { render, staticRenderFns } from "./SubmitTender.vue?vue&type=template&id=6adb06fd&scoped=true&"
import script from "./SubmitTender.vue?vue&type=script&lang=js&"
export * from "./SubmitTender.vue?vue&type=script&lang=js&"
import style0 from "./SubmitTender.vue?vue&type=style&index=0&id=6adb06fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb06fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adb06fd')) {
      api.createRecord('6adb06fd', component.options)
    } else {
      api.reload('6adb06fd', component.options)
    }
    module.hot.accept("./SubmitTender.vue?vue&type=template&id=6adb06fd&scoped=true&", function () {
      api.rerender('6adb06fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/SubmitTender.vue"
export default component.exports